import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { Images } from '../assets';
import { ContentData } from '../interface';
import ClaimContainer from './ClaimContainer';

export interface PaperWalletOTPContainerProps {
  content?: ContentData;
  email: string;
  otp: string;
  error?: string;
  logoUrl?: string;
  onClickRequestNewCode: () => void;
  onChangeOTP: (event: string) => void;
}

const PaperWalletOTPContainer = ({
  content,
  email,
  otp,
  error,
  logoUrl,
  onChangeOTP,
  onClickRequestNewCode
}: PaperWalletOTPContainerProps) => {
  const theme = useTheme();

  return (
    <Box>
      <ClaimContainer
        image={logoUrl || Images.MOJITO_LOGO}
        title={content?.title || 'Connect your wallet'}
        description={`Please enter the code sent to <br/><b>${email} by "thirdweb"</b>`}
      />
      <MuiOtpInput
        inputMode="numeric"
        TextFieldsProps={{
          error: Boolean(error),
          inputMode: 'numeric',
          type: 'number'
        }}
        sx={{
          maxWidth: {
            sm: '100%',
            lg: '400px'
          },
          marginBottom: '16px',
          marginTop: '15px'
        }}
        gap={1}
        length={6}
        value={otp}
        onChange={onChangeOTP}
      />
      {error && (
        <Typography
          sx={{
            color: theme.MojitoClaim?.error,
            fontWeight: 400,
            fontSize: '14px',
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          {error}
        </Typography>
      )}
      <Typography
        sx={{
          fontSize: '12px',
          textAlign: 'center',
          fontWeight: 500,
          cursor: 'pointer',
          fontFamily: theme?.MojitoClaim?.font?.secondary
        }}
        onClick={onClickRequestNewCode}
      >
        Request new code
      </Typography>
    </Box>
  );
};

export default PaperWalletOTPContainer;
